import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import DashLoadStatusViewForm from './DashLoadStatusViewForm'
import DashLoadStatusEditForm from './DashLoadStatusEditForm'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import DashLoadStatusKeys from 'src/constants/locale/key/ForwardHub'

const { CngTabs } = components


function EditPage({ showNotification }) {
	const { id } = useParams()
  const { translate } = useTranslation([Namespace.DASH_LOAD_STATUS])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let dashLoadStatus = translate(
      Namespace.DASH_LOAD_STATUS,
      DashLoadStatusKeys.TITLE
    )

    return {
      dashLoadStatus
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <DashLoadStatusViewForm
							showNotification={showNotification}
							id={id}
							onFetchPreSuccess={(datum) => {
							// this is intentional
              }}
						/>
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.dashLoadStatus,
              tabContent: (
                <DashLoadStatusEditForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default EditPage